// extracted by mini-css-extract-plugin
module.exports = {"styledLink":"NavButtons_styledLink__2IMvY"};